import React from 'react';
import { Field, TextInput } from './fields';

const PersonalInfo = ({ data, errors, onChange }) => {
  const bind = (name) => ({
    name,
    value: data[name] || '',
    error: errors[name],
    onChange: (e) => onChange({ [name]: e.target.value }),
  });

  return (
    <>
      <h2>Identité</h2>
      <p className="section-desc">Vos coordonnées nous servent à vous contacter.</p>

      <div className="form-row two-cols">
        <Field label="Nom" required error={errors.nom}>
          <TextInput {...bind('nom')} autoComplete="family-name" />
        </Field>
        <Field label="Prénoms" required error={errors.prenoms}>
          <TextInput {...bind('prenoms')} autoComplete="given-name" />
        </Field>
      </div>

      <div className="form-row two-cols">
        <Field label="Sexe" required error={errors.sexe}>
          <div className="radio-group">
            {[{ value: 'M', label: 'Masculin' }, { value: 'F', label: 'Féminin' }].map(opt => (
              <label key={opt.value} className={`radio-option ${data.sexe === opt.value ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="sexe"
                  checked={data.sexe === opt.value}
                  onChange={() => onChange({ sexe: opt.value })}
                />
                {opt.label}
              </label>
            ))}
          </div>
        </Field>
        <Field label="Date de naissance" required error={errors.date_naissance}>
          <TextInput type="date" {...bind('date_naissance')} />
        </Field>
      </div>

      <div className="form-row two-cols">
        <Field label="Téléphone 1" required error={errors.telephone} hint="8 chiffres, ex. 66123456">
          <TextInput type="tel" inputMode="tel" maxLength={12} {...bind('telephone')} autoComplete="tel" />
        </Field>
        <Field label="Téléphone 2" error={errors.telephone_2} hint="Facultatif">
          <TextInput type="tel" inputMode="tel" maxLength={12} {...bind('telephone_2')} />
        </Field>
      </div>

      <Field label="E-mail" error={errors.email}>
        <TextInput type="email" {...bind('email')} autoComplete="email" />
      </Field>
    </>
  );
};

export default PersonalInfo;
